import { z } from "zod/mini"

const SeparatorConfigSchema = z.object({
	label: z.nullish(z.string()),
})

export const SeparatorModelSchema = z.object({
	type: z.literal("Separator"),
	config: z.optional(SeparatorConfigSchema),
})

export type SeparatorModel = z.infer<typeof SeparatorModelSchema>
